var Backbone = require('backbone'),
    _ = require('underscore'),
    $ = require('jquery'),
    moment = require('moment'),
    UTRNoteVersion3TextParser = require('./utrNoteVersion3TextParser');

require('../../FV/extension/moment');

var HIT_CLASS =  'hit',
    PRE_TAGS = ['<span class="' + HIT_CLASS + '">' ], /*not escaped by span is harmless */
    POST_TAGS = ['</span>'],
    reHasHit = new RegExp(PRE_TAGS[0], 'g'),
    reTestHasHit = new RegExp(PRE_TAGS[0]); //(no global)


/**
 * TODO: clarify terminology now that referring to 'notes', not pages
 * Note: now stored as an instance on the document model for the viewer ( this is going to be taken out of DV )
 * The attributes are the results retrieved from ES.
 * A lot of this can now be set on parse after fetch and cached (not always returned in functions) ...
 * Performance can be enhanced with a lot of the functional stuff here.
 * No longer makes sense for this to be a Backbone Model.
 * 2/1/22: with upgrade to ES7 there is a breaking schema changes
 */

var props = {

    // perhaps store these in state now
    searchText: '',
    docId: null,
    fetchUrl: null,

    docNotOnES: null,
    fetchErrorJQXHR: null,

    // TODO: could use MSEARCH -- check if lowest version allows for it
    // With need to always perform two queries always now (to show doc notes w/out hits), store these here, not on data attributes
    q1: null,
    q2: null,

    // The previous & now current (adapted to fit old model) access point to all the necessary data
    // Generated in _setHits from a combo combo of q1 and q2 data
    // Accessible from this._getAllNoteHits
    hits: null,

    schemaVersion: null, // Property appeared when upgrading to when updating to support to ES7 and corresponding ES FDD schema version 3, which had breaking changes

    ajaxQueue: {}, //not yet implemented -- would be for 'abortAjaxRequests'
    fetchAborted: null //flag used to allow resolution of fetch (dfd) in case document switched (DVBC-1065)

};


module.exports = Backbone.Model.extend({
    // Return the array of 'note hits' found in the search.
    // ( will only be one for UTR notes )
    // Now the single access point in getting necessary data post fetch
    _getAllNoteHits: function() {
        return this.hits.hits.hits;
    },
    // Only one of these will exist, the other will be undefined --  both passed in init.
    constructor: function( attrs, options ) {

        _.extend( this, props, _.pick( options, 'searchText', 'docId', 'fetchUrl'), {
            parse: false, // custom fetch
            query:  this._constructESQuery( options.searchText, options.docId, options.additionalSearchClauses )
        });

        Backbone.Model.prototype.constructor.apply(this, arguments);
    },

    _constructESQuery: function(textQuery, docId, additionalSearchClauses) {

        // Query constructed to work with both ES versions supported by Feith -- 1.7 and 5.2.
        var v1orv5Query =  {
            query: {
                bool: {
                    must: [
                        { term: {doc_id: docId} }, // have doc_id first -- this is for ES plugin to know that that first item in the array is the DOC id , if may check it
                        { query_string: {query: textQuery} }
                    ]
                }
            },
            highlight: {
                pre_tags: PRE_TAGS, // not escaped by span is harmless
                post_tags: POST_TAGS,
                encoder: 'html', //escape
                // what fields to highlight -- here all
                fields: {
                    '*': { number_of_fragments: 0 } //dont filter
                },
                "require_field_match": false  //this is required for version 5.2, not 1.7.6 -- in latter, was false by default; in former, true is the default
            }
        };

        if (additionalSearchClauses && additionalSearchClauses.length > 0) {
            var newMust = v1orv5Query.query.bool.must.concat( additionalSearchClauses );
            v1orv5Query.query.bool.must = newMust;
        }

        return v1orv5Query;

    },

    /**
     * Note: really the results of the search -- not the model 'fetch' in the Backbone sense.
     * contentType: previoulsy ,'text/plain', though to hit ES directly now need application/json; this is also now working for the proxy
     */
    fetch: function(cxt) {

        var self = this,
            cxt = cxt || self,
            ajaxOps = {
                url: this.fetchUrl,
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                context: cxt
            };

        return $.Deferred( function($dfd ) {
            
            $.ajax( _.extend( ajaxOps, { data: JSON.stringify(self.query) } )).done( function(data)  {
                    
                    /*  quick fix to prevent run time errors when switch docs fast in the viewer (on reset, query would now be null)
                        should really be taken care of in outside workflow -- though no one uses this anyway in doc viewer
                     */
                    if (!self.query)
                        return;

                    self.q1 = data;
                    /* if searching for all doc notes, will always need the second query to get ones without hits */
                    /* need to search again with NO QUERY to get results for document notes that wouldn't have highlights
                     * -- prior: was only doing this if no utr_note hits were returned */

                    //TODO: may be better to have 2 searches and use MSEARCH
                    //TODO: now that we have gotten rid of providing a 'pass through' query -- may be more clear to just create a separate query for this one
                    var q = _.clone(self.query);
                    q.query.bool.must.splice(1); //remove not just the search term but also all the others

                    $.ajax( _.extend( ajaxOps,{ data: JSON.stringify( q ) })).done( function( data ) {

                        /*  quick fix to prevent run time errors when switch docs fast in the viewer (on reset, query would now be null)
                            should really be taken care of in outside workflow -- though no one uses this anyway in doc viewer
                         */
                        if ( !self.query )
                            return;

                        var hits = data.hits.hits;

                        self.q2 = data;

                        /* CHECK IF THE DOC IS IN THE ELASTIC SEARCH SERVER -- MUST DO ON SECOND REQ */

                        if ( hits[0] === undefined ) {
                            self.docNotOnES = true; //set flag to be picked up on render
                        }
                        else
                        {
                            /**
                             * Store the version here -- after docNotOnEsCheck and called to set hits.
                             * If no documents returned, we can't get the schema version for any of the hits.
                             * I think a bunch of functions in here check perform a preliminary check before returning data --
                             * this is good but in real world could be moot -- since the data is not fetched if this is the case, so maybe we remove.
                             * Refactor Candidate.
                             * Need to make sure any functions that would call know schema version this in advance.
                             */
                            self.schemaVersion = parseFloat( data.hits.hits[0]._id.split(':')[1] );
                        }

                        self.hits = self._setHits( self.q1, self.q2 );

                        !self.fetchAborted && $dfd.resolveWith( cxt );

                    }).fail( onJqXHRFail );

            }).fail( onJqXHRFail );

            function onJqXHRFail(jqXHR) {

                self.fetchErrorJQXHR = jqXHR;
                !self.fetchAborted && $dfd.rejectWith(cxt, [jqXHR]);

            }

        }).promise();

    },

    // LOGIC HERE IS EVOLVED SLOP ... BUT ES SCHEMA IS GOING TO CHANGE ANYWAY (from notes to documents) SO DEAL WITH IT FOR NOW
    // ( update 2/28/19 - this comment is old ... doubtful the ES schema will change now ... need to clean this up )

    // Set up this.hits as it was done before doc notes were introduced where they were set once, from either the first or second query.
    // Previously, this.hits would have been stored on model attributes after a fetch.
    // Since we're now always performing 2 queries, setting models attrs would override one another,
    // so here we return a munged combination of the both.

    _setHits: function(q1, q2) {

        var q1Hits = q1.hits.hits,
            q2Hits = q2.hits.hits,

            // Ah: perhaps this doesn't apply if there is no highlight AND if there is no note_* 
            // in the _source -- UTR will exist with metadata for a document with no pages (eg folders). ???
            utrNoteHitsReturnedinFirstQuery = q1Hits.length > 0 && _.find( q1Hits, function(h) {
                return h._source.type === 'U';
            }),

            // Use q1 as the base if UTR notes exists in the first query (pages found), otherwise use query 2.
            // Note: DVBC-1176 -- if document is a FOLDER, it will never have any UTR notes highlights --
            // notes may exist, but there will never be a note_* attribute on the source.
            resp = utrNoteHitsReturnedinFirstQuery ? q1 : q2,

            // Add any doc note hits from q2 that didn't exist in q1 to the resp to return.
            docNoteHitsReturnedinSecondQuery = _.filter( q2Hits , function( h ) {
                return h._source.type === 'T' || h._source.type === 'X';
            }),
            docNoteHitsFirstQuery = _.filter( q1Hits, function( h ) {
                return h._source.type === 'T' || h._source.type === 'X';
            }),
            docNoteIdsInFirstQuery = _.pluck( docNoteHitsFirstQuery, '_id' );

        // DVBC-1487 -- can no longer rely on sequence (could have the same in doc and page notes, so identify by id).
        // Note -- DVBC-1489 -- this really needs be cleaned: eg,
        // a dupe doc note can be added to the end of the resp array if a hit in first query if no utr notes returned in the 1st query
        // ... though this doesn't seem to cause any issue with current logic.
        // I expect this to change with the introduction of page text notes.

        _.each( docNoteHitsReturnedinSecondQuery, function(h) {
            if ( !_.contains( docNoteIdsInFirstQuery, h._id )) {
                resp.hits.hits.push(h);
            }
        });

        // If there were no UTR page hits in the first query, add highlights of doc notes from q1 
        // to corresponding DOC NOTE(!) hits in the resp (here would be second query)
        // DVBC-1101: in q2 no doc notes have highlights.
        if (!utrNoteHitsReturnedinFirstQuery) {

            var docNoteHitsFirstQueryWithHighlights = _.filter(docNoteHitsFirstQuery, function(h) {
                return h.highlight !== undefined;
            });

            _.each( docNoteHitsFirstQueryWithHighlights, function(h) {
                var correspondingNoteHit = _.find( resp.hits.hits, function( correspondingHit ) {
                    return h._id === correspondingHit._id;
                });
                correspondingNoteHit && (correspondingNoteHit.highlight = h.highlight);
            });
        }

        return resp;
    },
    // These are really UTR NOTES (or rather the contents of all UTR notes in the document)
    getPageTextObjs: function(esGrep, localGrepStr) {

        var aPgTxtObjs = this._getArrayOfPageTextObjs();

        if (esGrep)
            aPgTxtObjs = this._getArrayOfGreppedPageTextObjs(aPgTxtObjs);

        if (localGrepStr)
            aPgTxtObjs = this._getArrayOfLocalGreppedPageTextObjs(aPgTxtObjs, localGrepStr);

        return aPgTxtObjs;
    },
    /**
     * Return array of { pgNum, pgId, pgText }
     * If hits, take from the highlight for 'highlighting', otherwise, take from the source.
     * Highlights won't have hits if not found, so NEED THE SOURCE in case not found -- not just the highlight section.
     * docPgsIds:
     * - now not using a separate function to get these -- so consider this the central pt for obtaining page ids
     * - normalize them into an array: if there's only one page in the document, the value will not be an array (otherwise it will)
     * - Also note: it will be undefined if the document has no pages; but this is ok b/bc the variable will not be referenced in this routine
     *   in the for loop below because the # of pages will be 0.
     * Pageless documents:
     * - should work ... see notes ... if there are fields but no pages, # returned will just be zero.
     * - if no properties returned at all, it will appears as 'Document Not on ES Server' ( DVBC-1852 )
     * Version differences:
     * - version < 3: didn't employ a notes array;  had properties on the source highlights, eg { .note_#: text }*
     * - version 3:
     *      - the note field were replaced with an array of notes
     *      - value in the array is the text prefixed by "FDDPage 2: ";
     *      - the prefix is necessary to link the page number in the highlights section
     */
    _getArrayOfPageTextObjs: function() {

        var aPagesText = [],
            pageSource = this._getDocumentPageSource(),
            aPageHighlightResults = this._getUTRNoteHighlightResponse(),
            docPgsIds =  pageSource.doc_pg_ids instanceof Array ? pageSource.doc_pg_ids : [pageSource.doc_pg_ids],
            numberPgsInDocument = this.numberOfPgsInDoc();


        if ( this.getSchemaVersion() < 3 ) {

            var pageKeysWithHits = this._UTRNoteHasPageResults() // ( superflous in this routine )
                    ? Object.keys( aPageHighlightResults )
                    : [], // use empty array if none returned
                pageKey,
                pgNum,
                pgId;

            for ( var i = 0; i < numberPgsInDocument; i++ ) {

                pgNum = i + 1;
                pageKey = 'note_' + pgNum; // ( pages are in page seq order )

                // Set pageIds from the doc page ids array.  This should work b/c the array of pg ids should be in seq order.
                // Though we could run into problems: eg if user reorders doc pages and UTR is not re-run.
                // Note: ES is not storing page sequence
                pgId = docPgsIds[i];

                aPagesText[i] = _.contains( pageKeysWithHits, pageKey )
                    ? {
                        pgNum: pgNum,
                        pgId: pgId,
                        pgText: aPageHighlightResults[pageKey][0]
                    }
                    : {
                        pgNum: pgNum,
                        pgId: pgId,
                        pgText: pageSource[pageKey]
                    };
            }

            return aPagesText;
        }

        /* --- Version 3+ --- */

        var aSourceNotes = pageSource.note; // These should always exist
        var aHighlightNotes = this._UTRNoteHasPageResults() ? aPageHighlightResults.note : [];


        var aHighlightPgNumbersByText = aHighlightNotes.reduce( function( obj, pageTextWithDelimiter ) {

            var pgNumberAndText = UTRNoteVersion3TextParser.getPageNumberAndText( pageTextWithDelimiter );
            obj[pgNumberAndText.pgNumber] = pgNumberAndText.pgText;
            return obj;

        }, {} );

        // If page is in the highlight, use it -- can tell by getting the 1st un-delimited
        // ( pages are in seq order )
        for (var i = 0; i < numberPgsInDocument; i++) {

            var actualPageNumber = i + 1; // ( base 1 )

            // Should make class -- not a literal -- now its context of a template
            var pageTemplateData = {
                pgNum: actualPageNumber,
                pgId: docPgsIds[i]
            };

            /* Higlights are base 1 ( actual #; source is base 0 */
            var pageText = aHighlightPgNumbersByText[actualPageNumber]
                ? aHighlightPgNumbersByText[actualPageNumber]
                : UTRNoteVersion3TextParser.getPageText( aSourceNotes[i] );

            pageTemplateData['pgText'] = pageText;

            aPagesText[i] = pageTemplateData;

        }

        return aPagesText;



    },
    // Only return lines with hits (and pages with lines with hits).
    _getArrayOfGreppedPageTextObjs: function( allPgTextObjects ) {

        allPgTextObjects = allPgTextObjects || this._getArrayOfPageTextObjs();

        var aPgsWithHits = _.filter( allPgTextObjects , function(p) {
            return reTestHasHit.test(p.pgText);
        });

        return _.map(aPgsWithHits, function(p) {

            var aLinesWithHits = _.filter( p.pgText.split('\n') , function(line) {
                return reTestHasHit.test(line);
            });

            return {
                pgNum: p.pgNum,
                pgId: p.pgId,
                pgText: aLinesWithHits.join('\n')  // Note: put back the new line char that got stripped from split
            };
        });
    },

    _getArrayOfLocalGreppedPageTextObjs: function( aPgTxtObjs, localGrepStr ) {

        aPgTxtObjs = aPgTxtObjs || this._getArrayOfPageTextObjs();

        var reTestLocal = new RegExp(localGrepStr, 'i');
        var reReplace = new RegExp( '(<span class="hit")(>)', 'gi' ); // continue using?

        var aPgsWithHits = _.filter( aPgTxtObjs, function(p) {
            return reTestLocal.test(p.pgText);
        });

        return _.map(aPgsWithHits, function(p) {

            var pgText = p.pgText,
                pgNum = p.pgNum;

            var aLinesWithNumberedHits = _.map( pgText.split('\n'), function(line, i) {
                return line.replace(reReplace, function(match, p1, p2) {
                    return p1 +  ' data-pg="' + pgNum + '" data-line="' + i + '"' + p2;
                });
            });

            var aLinesWithHits = _.filter( aLinesWithNumberedHits , function(line, i) {
                return reTestLocal.test(line);
            });

            /*        
                var aLinesWithHitsInLinesNumbered = _.map(aLinesWithHits, function(line, i) {
                    debugger;
                    //set data attribute of each hit in the line
                });
            */

            return {
                pgNum: p.pgNum,
                pgId: p.pgId,
                pgText: aLinesWithHits.join('\n')
            };
        });

    },

    getFCFields: function( localGrepStr, includeNonHits ) {

        var flds = this._getAllFCFields(includeNonHits);
        flds = order(flds); //sort: if toggle btn local/es grep, may get diff order

        if (!localGrepStr)
            return _.keys(flds).length > 0 ? flds : null;

        return this._getLocalGreppedDocProperties(flds, localGrepStr);

    },
    // Return key, value of the hits -- null if empty.
    // Note: the keys are string of unwanted prefix.
    _getAllFCFields: function( includeNonHits ) {
        
        // First get any with hits
        var fieldsWithHits = this._getFCFields(true);
        if (!includeNonHits)
            return fieldsWithHits;

        // Then get those without hits (if desired)
        var fieldsWithoutHits = this._getFCFields(false);

        // Merge them, with precedence to the hits
        return _.extend( fieldsWithoutHits, fieldsWithHits );

    },

    /**
     * Return Hash Of 'Display Field Name' (no prefix identifier) X Field Value {actual field name: field value}
     * If from hits, the value will contain HTML markup; if not, its text.
     * fromHits: get the properties from the highlight or src section of the response.
     */
    _getFCFields: function( fromHits ) {

        var resp = this[fromHits ? '_getFirstNoteHitHighlightResp' : '_getFirstNoteHitSourceResp']();

        if ( !resp || resp.length < 1 )
            return null;

        var ret = {};

        if ( this.getSchemaVersion() < 3 ) {

            /**
             *  DVBC-1486 -- for the source response -- fc_flx and fc_fld values are the same but we can't just filter for one:
             *  'x' values are indexed differently (stemming, tokenizing, etc.. ) than 'd' values, so sometimes a search will include
             *  one but not the other or both in the 'highlights' section.  If both are returned, ES could make the hit
             *  in HTML differently depending on the search, but give precedence to 'x'.
             *  TODO: common code for getting 'x' vs 'd' values -- do after init imple of props ...
             */
            for ( var k in resp ) {

                if ( k.indexOf('fc_fl') < 0 )
                    continue;

                var isX = k.indexOf('fc_flx') > -1,
                    displayKey = k.substr(9, k.length); // Can be diff types, can't just replace txt to get the display value (eg: ..._c_ )

                if (isX) {
                    //fc_flx: Remove 'd' (if exists) to eliminate dupes
                    var dKey = _.find(_.keys(resp), function (k) {
                        return k.indexOf('fc_fld') > -1 && k.indexOf(displayKey) > -1;
                    });
                    dKey && delete resp[dKey];
                    ret[displayKey] = fromHits ? resp[k][0] : resp[k];

                } else {
                    // fc_fld:
                    // Check if there's a 'x' of the same 'name', if so use that instead (will be picked up later in iteration);
                    // If not, use the value of the 'd'
                    var xKey = _.find(_.keys(resp), function (k) {
                        return k.indexOf('fc_flx') > -1 && k.indexOf(displayKey) > -1;
                    });

                    !xKey && ( ret[displayKey] = fromHits ? resp[k][0] : resp[k] );
                }
            }

        } else {

            /* With version 3 the 'fc-flx_c' fields were removed.  We now only have 'fc_fld_c_' fields. */

            for ( var k in resp ) {

                if ( k.indexOf('fc_fld') > -1 ) {

                    var displayKey = k.substr( 9, k.length ); // share this?
                    ret[displayKey] = fromHits ? resp[k][0] : resp[k];
                }

            }

        }

        return Object.keys(ret).length > 0 ? ret : null;

    },

    // TODO: common code w/ fields, security, rma properties ... but refactoring anyway
    getDocProperties: function(localGrepStr, includeNonHits) {

        var docProps = this._getAllDocProperties(includeNonHits);
        docProps = order(docProps); //sort: if toggle between local/es grep, may get diff order

        if (!localGrepStr)
            return _.keys(docProps).length > 0 ? docProps : null;

        return this._getLocalGreppedDocProperties(docProps, localGrepStr);
    },

    _getAllDocProperties: function( includeNonHits ) {
        //First get any with hits
        var withHits = this._getDocProperties(true);
        if (!includeNonHits) return withHits; //(null if none)

        //Then get those without hits (if desired)
        var withoutHits = this._getDocProperties(false); //(null if none)

        //(merge them, with precedence to the hits)
        return _.extend(withoutHits, withHits);
    },
    _getDocProperties: function( fromHits ) {

        var resp = this[fromHits ? '_getFirstNoteHitHighlightResp' : '_getFirstNoteHitSourceResp']();

        if (!resp || resp.length < 1)
            return null;
        
        var ret = {};

        if ( this.getSchemaVersion() < 3 ) {

            for (var k in resp) {

                // Will be doc_prox and doc_prop
                // Sometimes not the same value so can't filter out; if both found, give precedence to the 'X'
                if (k.indexOf('doc_pro') < 0)
                    continue;

                var isX = k.indexOf('doc_prox') > -1, //(to distinguish from doc prop)
                    displayKey = k.substr(11, k.length);

                if (isX) {
                    //remove any doc_prop (if exists) to eliminate dupes
                    var docPKey = _.find(_.keys(resp), function (k) {
                        return k.indexOf('doc_prop') > -1 && k.indexOf(displayKey) > -1;
                    });
                    docPKey && delete resp[docPKey];
                    ret[displayKey] = fromHits ? resp[k][0] : resp[k];

                } else { //doc_prop

                    // check if there's a doc_prox, if use that instead (will be pick up later in iteration);
                    // if not, use the value of the 'p'
                    var xKey = _.find(_.keys(resp), function (k) {
                        return k.indexOf('doc_prox') > -1 && k.indexOf(displayKey) > -1;
                    });

                    !xKey && ( ret[displayKey] = fromHits ? resp[k][0] : resp[k] );
                }
            }
        }
        else
        {
            /* With version 3 doc_prox is gone just like fc_flx. We now only have 'doc_prop' fields. */
            for ( var k in resp ) {

                if ( k.indexOf('doc_prop') > -1 ) {
                    var displayKey = k.substr( 11, k.length );
                    ret[displayKey] = fromHits ? resp[k][0] : resp[k];
                }
            }
        }

        return Object.keys(ret).length > 0 ? ret : null;

    },

    // Return Security or RMA metadata applied to the Document.
    // If isSecurity -- return security properties, otherwise return RMA properties.
    // (Later may be better to break apart, but now going for code reuse).
    getSecurityOrRMAProperties: function( localGrepStr, includeNonHits, isSecurity ) {

        var rmaOrSecurityProps = this._getAllSecurityOrRmaProperties( includeNonHits, isSecurity );

        // sort: if toggle between local/es grep, may get diff order
        rmaOrSecurityProps = order(rmaOrSecurityProps);

        if (!localGrepStr)
            return _.keys(rmaOrSecurityProps).length > 0 ? rmaOrSecurityProps : null;

        return this._getLocalGreppedDocProperties(rmaOrSecurityProps, localGrepStr);

    },

    _getAllSecurityOrRmaProperties: function( includeNonHits, isSecurity ) {

        var withHits = this._getSecurityOrRMAProperties( 1, isSecurity );

        if (!includeNonHits)
            return withHits;

        var withoutHits = this._getSecurityOrRMAProperties( 0, isSecurity );

        return _.extend (withoutHits, withHits );
    },

    /**
     * The 'Big 5': Return Security if isSecurity provided, otherwise, RMA.
     * Return object of 'Display Name' x Value; return null if none exist.
     * Note: the value is an array that can contain a mixture of html and text (hits and non hits)
     * If hits ... will be array of [<span class="hit">Record</span>, <span class="hit">Record</span>] ... so dealing with the html here anyway ....
     */
    _getSecurityOrRMAProperties: function( fromHits, isSecurity ) {

        var firstNoteHitHighlightResp = this._getFirstNoteHitHighlightResp(),
            firstNoteHitSrcResp = this._getFirstNoteHitSourceResp(); // prob bad naming here; if no hits in q1 will be not src, so q2 ... anyway it's always returning the values

        // Use 'resp' as base to build return obj -- if there is a hit and fromHits,
        // need to combo it with the non hits (the latter won't be included) -- ( so its not 1 or the other like other categories here ).
        var resp = fromHits ? firstNoteHitHighlightResp : firstNoteHitSrcResp;

        if (!resp || resp.length < 1)
            return null;

        var ret = {};

        // May want to make own obj or at least own fns -- more flexibility in the future ... get going first .....

        if (isSecurity) {

            // Classification:  There is only one allowed for this one; don't need to check for others that aren't hits, if there are hits

            var classifications = this._getRMAorSecurityProperty( 'class_name', firstNoteHitHighlightResp, firstNoteHitSrcResp, fromHits, 1 ),
                markings = this._getRMAorSecurityProperty( 'mark_name', firstNoteHitHighlightResp, firstNoteHitSrcResp, fromHits ),
                countries = this._getRMAorSecurityProperty( 'country_name', firstNoteHitHighlightResp, firstNoteHitSrcResp, fromHits );

            classifications && ( ret['Classification'] = classifications );
            markings && ( ret['Marking'] = markings );
            countries && ( ret['Countries'] = countries );


        } else {   // RMA

            // Categories: upcoming cat_id ... not sure how will handle ...

            // States:
                // Could be 'dupes' -- unique state is made of name & description, but ES only stores the name.
                // Could return unique list but leaving the dupes to show that more were assigned.

           var categories = this._getRMAorSecurityProperty( 'cat_name', firstNoteHitHighlightResp, firstNoteHitSrcResp, fromHits ),
               states = this._getRMAorSecurityProperty( 'state_name', firstNoteHitHighlightResp, firstNoteHitSrcResp, fromHits );

            categories && ( ret['Categories'] = categories );
            states && ( ret['States'] = states );

        }

        return _.keys(ret).length > 0 ? ret : null;

    },
    /* For RMA/Security Properties, there is no '_x' suffix in the keys */
    _getRMAorSecurityProperty: function( propName, firstNoteHitHighlightResp, firstNoteHitSrcResp, fromHits, onlyOneValuePossible ) {

        var aTextToReturn = fromHits
            ? firstNoteHitHighlightResp[propName] ? firstNoteHitHighlightResp[propName] : null
            : firstNoteHitSrcResp[propName] ? firstNoteHitSrcResp[propName] : null;

        if (!aTextToReturn)
            return null;

        // Note: clone required to not change the actual source value ( can be not when merging hits and non hits )
        aTextToReturn = aTextToReturn instanceof Array ? _.clone(aTextToReturn) : [ _.clone(aTextToReturn) ];

        if (fromHits && !onlyOneValuePossible)
            aTextToReturn = combineHitsAndNonHits( aTextToReturn, propName );

        // Sort the values to consistently display them in order.
        // They can appear differently if modified in 'combineHitsAndNonHits' or if taken from hit/no hits.
        return onlyOneValuePossible
            ? aTextToReturn
            : sortMixedTextAndHtmlValues( aTextToReturn );

        /**
         * If from hits, need to include others that weren't highlighted.
         * Purpose is to show all properties and highlight the hits -- not just the hits (if searching from hits).
         * Could further condense code here but leaving being more verbose
         * If not from hits, should return all anyway.
         * At least for an attempt at clarity -- can later change when do some more testing -- and in case later changes need to be made for each category
         * Hit array eg -- "<span class="hit">Frozen</span>", "<span class="hit">Record</span>"
         */
        function combineHitsAndNonHits( hitsArray, propName ) {

            // Get unique 'hits' utilizing jQuery as a convenience -- these will either be
            // markup (<span class="hit">Frozen</span>) or a mixture of it ("Unit <span class="hit">Manning</span> Documents)
            // mixture require to wrap in $div
            var uniqueHitsAsText = _.map( hitsArray, function( hit ) {
                return $('<div>').html(hit).text();
            });

            // Get non hits to see if there's a difference (these will be text)
            // If there is, add the text values to the array to return.
            var nonHits = firstNoteHitSrcResp[propName],
                nonHitsNotIncluded = _.difference( nonHits, uniqueHitsAsText );

            (nonHitsNotIncluded.length > 0) &&
                ( hitsArray = hitsArray.concat( nonHitsNotIncluded ) );

            return hitsArray;

        }

        // Sort array of items that can either be text or mixed text and html by their text values/
        // This could be a jq / underscore / util helper fn
        function sortMixedTextAndHtmlValues( unsortedValues ) {

            var textByMixedHtmlValues = _.map( unsortedValues, function(v) {
                return {
                    textValue: $('<div>').html(v).text(), // TODO: This could also be a helper ...
                    mixedHtmlValue: v
                };
            });

            var sortedByTextValue = _.sortBy( textByMixedHtmlValues, 'textValue' );

            return _.pluck( sortedByTextValue, 'mixedHtmlValue' );

        }

    },

    getDocNotes: function(esGrep, localGrepStr, includeNonHits) {

        var docNotes = this._getAllDocNotes(includeNonHits);

        if (esGrep)
            docNotes = this._getGreppedDocNotes(docNotes);

        if (localGrepStr)
            docNotes = this._getLocalGreppedDocNotes(docNotes, localGrepStr);


        return docNotes;
    },

    /* Return object of Doc Note Sequence By 'Display Value' to Return or null if none exist */
    _getAllDocNotes: function(includeNonHits) {

        var ret = {},
            allDocNoteHits = this._getDocNoteHitsResp(); // Those w/and w/out highlights -- next split into groups

        if ( this.getSchemaVersion() < 3 ) {

            // Could loop and split for perf to create the 2 below
            var hitsWithHighlights = _.filter(allDocNoteHits, function(hit) {
                if (!hit.highlight) return false;
                return _.filter( _.keys(hit.highlight), function(k) {
                        return k.indexOf('note_') > -1;
                    }).length > 0;
            });

            var hitsWithoutHighlights = _.filter(allDocNoteHits, function(hit) {
                if (!hit.highlight) return true;
                return _.filter(  _.keys(hit.highlight) , function(k) {
                        return k.indexOf('note_') > -1;
                    }).length < 1;
            });

            // Always do the highlights first
            _.each( hitsWithHighlights , function(hit, i) {
                var src = hit._source;
                var highlight = hit.highlight;
                for (var k in highlight) {
                    // Use sequence as identifier -- perhaps could store more data about the note on data-attr's
                    if (k.indexOf('note_') > -1) {
                        ret[ src.seq ] = createNoteValueLine(highlight[k][0], src.author, src.created, src.seq );
                    }
                }
            });

            if (!includeNonHits)
                return _.keys(ret).length > 0 ? ret : null;

            // Non Highlights -- unlike with pages, this is optional to include; get text from src, not the highlights
            _.each( hitsWithoutHighlights , function(hit, i) {
                var src = hit._source;
                for (var k in src) {
                    if (k.indexOf('note_') > -1) {
                        ret[ src.seq ] = createNoteValueLine(src[k], src.author, src.created, src.seq);
                    }
                }
            });

        }

        else
        {
            // Should use one loop for performance ...
            var hitsWithHighlights = allDocNoteHits.filter( function( hit ) {
                return hit.highlight && hit.highlight.note;
            });

            var hitsWithoutHighlights = allDocNoteHits.filter( function(hit) {
                return !hit.highlight || !hit.highlight.note;
            });

            // Always do the highlights first --
            hitsWithHighlights.forEach( function(hit, i) {
                var src = hit._source;
                var noteText = hit.highlight.note[0]; // should only ever be one
                // Use sequence as identifier -- perhaps could store more data about the note on data-attr's
                ret[ src.seq ] = createNoteValueLine( noteText , src.author, src.created, src.seq );
            });

            if ( !includeNonHits )
                return Object.keys(ret).length > 0 ? ret : null;

            // Non Highlights -- unlike with pages, this is optional to include; get text from src, not the highlights
            //
            hitsWithoutHighlights.forEach( function( hit ) {
                var src = hit._source;
                var noteText = src.note[0];
                ret[ src.seq ] = createNoteValueLine( noteText, src.author, src.created, src.seq );

            });

        }

        return Object.keys(ret).length  > 0 ? ret : null;

        /**
         * Returning html as easy hack to keep on same line, allowing to keep grep functionality --
         * if gets more complex prob will want to create new collection view.
         * could try breaking by br? (not 'n')
         * This should really be done in the view layer; this is a quick shortcut.
         * TODO:
         * - put esdn line around what will be the key -- esDNLine
         */
        function createNoteValueLine(noteText, author, created, seq) {

            return '<span class="esDN" data-seq="' + seq + '">' +
                '<span class="esDNKey">' +
                    '<span class="esDNAuthor">' + author + '</span>' +
                    '<span class="esDNTime">(' + moment.convertDBTimeToLocalTime(created) + ')</span>:' +
                '</span>'  +
                noteText +
            '</span>';
        }

    },
    _getGreppedDocNotes: function(allDocNotes) {
        allDocNotes = allDocNotes || this._getAllDocNotes(false);
        var ret = {};
        for (var seq in allDocNotes) {
            var aLinesWithHits = _.filter( allDocNotes[seq].split('\n'), function(line) {
                return reTestHasHit.test(line);
            });
            ret[seq] = $.trim( aLinesWithHits.join('\n') ); //trim so lines don't break in ui on the first, last ...
        }
        return _.keys(ret).length > 0 ? ret : null;
    },
    _getLocalGreppedDocNotes: function(docNotes, localGrepStr) {

        docNotes = docNotes || this._getAllDocNotes(false);

        var reHasLocalHit = new RegExp(localGrepStr, 'i'),
            greppedNotes = {},
            docNotesWithHits = {};

        // First filter out notes that don't contain localGrepStr
        for (var seq in docNotes) {
            if (reHasLocalHit.test(docNotes[seq]))
                docNotesWithHits[seq] = docNotes[seq];
        }

        // Now filter for lines of the note text that contain localGrepStr
        for (var seq in docNotesWithHits) {

            var aLinesWithHits = _.filter( docNotesWithHits[seq].split('\n'), function(line) {
                return reHasLocalHit.test(line);
            });

            greppedNotes[seq] = $.trim( aLinesWithHits.join('\n') ); //trim so lines don't break in ui on the first, last ...
        }

        return _.keys(greppedNotes).length > 0 ? greppedNotes : null;

    },
    /*
     * Take a 'docProperties obj' and only return properties whose key or value matches localGrepStr.
     * Returns null if nothing matches.
     * 'DocProperties obj' is whats returned for FC Fields, Doc Properties, RMA, & Security
     * ( currently the doc meta data we're interested in ).
     * It's what currently populates their display templates.
     * Search both the key and value b/c 'keys' are also searched by SAT.
     * docProperties: an array of key, 'display values'; 'display values' can be an array ( the case for RMA & Security )
     * localGrepStr: the string to search
     */
   _getLocalGreppedDocProperties: function(docProperties, localGrepStr) {

        var lclGreppedProperties = {},
            reTestLocal = new RegExp(localGrepStr, 'i');

        for (var k in docProperties) {

            // Utilize jQ html to not search any potential html (eg <span class=hit>) which could come back in highlights.
            // Utilize a join for array values  (rmaOrSecurityProps are arrays, unlike doc props or fc fields).
            var propertyValue = docProperties[k] instanceof Array
                ? docProperties[k].join('')
                : docProperties[k];

            var valueToSearch = $('<div>').html( propertyValue ).text();
            var textToSearch = valueToSearch + k;

            if ( reTestLocal.test(textToSearch) )
                lclGreppedProperties[k] = docProperties[k];

        }

        return _.keys(lclGreppedProperties).length > 0 ? lclGreppedProperties : null;

    },
    // FC Fields and Doc Property metadata will be in any of the note fields.
    _getFirstNoteHitHighlightResp: function() {

        return this._hasAnyResults()
            ? this._getAllNoteHits()[0].highlight
            : null;

    },
    _getFirstNoteHitSourceResp: function() {

        if ( !this.docOnServerAndNoFetchErr() )
            return null;

        return this._getAllNoteHits()[0]._source;

    },

    /**
     * Return the first UTR note hit;
     * there should only ever be one for a document (these are document UTR notes )
     */
    _getUTRNoteHitResponse: function() {
        return _.find(  this._getAllNoteHits(), function(noteHitArray) {
            return noteHitArray._source.type === 'U';
        });
    },

    /* Return true if there's a UTR note highlight and it has 'page text' */
    _UTRNoteHasPageResults: function() {

        if ( !this.docOnServerAndNoFetchErr() )
            return false;

        var utrNoteHit = this._getUTRNoteHitResponse();
        if ( !utrNoteHit )
            return false;

        if ( !utrNoteHit.highlight )
            return false;


        if ( this.getSchemaVersion() < 3 ) {

            // IE doesn't support find, startsWith ... can later rid
            // _.findKey in later underscore version
            var hasNoteHighlightKey = _.find(Object.keys(utrNoteHit.highlight), function (k) {
                return k.substring(0, 5).indexOf('note_') > -1;
            });

            return hasNoteHighlightKey ? true: false;

        } else {

            return utrNoteHit.highlight.note ? true : false;

        }

    },
    _hasAnyResults: function() {

        if ( !this.docOnServerAndNoFetchErr() )
            return false;

        return _.filter( this._getAllNoteHits() , function(noteHitArray) {
            return  _.contains( _.keys(noteHitArray), 'highlight');
        }).length > 0;

    },
    _getDocNoteHitsResp: function() {

        return this._getAllNoteHits().filter( function(noteHitArray) {
            var noteType = noteHitArray._source.type;
            return noteType === 'T' || noteType === 'X';
        });

    },

    _getUTRNoteHighlightResponse: function() {
        var utrNoteHit = this._getUTRNoteHitResponse();
        return utrNoteHit ? utrNoteHit.highlight : null;
    },
    /*
     *  Return _source of the document's utr note: should always exists with the combo of queries 1 and 2
     *  (and should only be one).
     *   -- though can run into issues, eg: (utr notes not getting written to ES -- DVBC-1147
     *  Original purpose was to always return something to get the page text.
     *  Return null if no utr notes have been written.
     *  utrNoteHitsResponse would be null if utr notes aren't written
     * */
    _getDocumentPageSource: function() {
        var utrNoteHitsResponse = this._getUTRNoteHitResponse();
        return utrNoteHitsResponse
            ? this._getUTRNoteHitResponse()._source
            // case to handle issues for DVBC-1147
            // (really only used to prevent run time error -- this should always return something otherwise blank searches or those with no hits will not work (DVBC-1154)
            : null;
    },

    // Return the total # of hits.
    getNumberOfHits: function() {

        var allTextWithHits = this._getAllTextWithHits();
        if (allTextWithHits === '')
            return 0;

        // Perform an extra check to ensure match doesn't return null; this can occur when using IDOL proxy,
        // where allTextWithHits may not be blank if there are hits (DVBC-1114).
        var aHitMatches = allTextWithHits.match(reHasHit);

        return aHitMatches == null ? 0 : aHitMatches.length;

    },

    // Return the source of all 'highlights' from the note hit arrays.
    // De-dupe metadata: (doc props, fc fields, etc) will exist in all note hits; just return those from the first.
    // Used to calc total number of hits.
    // Left as a fn for now; prob better to set & cache on parse, along with everything else -- its called multi time on the same search.
    // REALLY NEED TO RE-WRITE THIS MODULE !

    // See DVBC-1488 -- this # should be off but it appears to work:
    // - not taking into account page text notes ('K') in set hits (so prob why these aren't counted)
    // - previously could have been wrong if not accepting 'd' or 'x' values as printed from the search,
    //      but that should now be fixed, (since using same search logic)

    _getAllTextWithHits: function() {

        var allNoteHitHighlights = this._getAllNoteHitHighlights();

        if (!allNoteHitHighlights || allNoteHitHighlights.length < 1)
            return '';

        var txt = '';

        // First get any 'metadata' (not notes) utilizing re-writing the logic from other fns.
        // ( It's more complicated to parse the metadata for non-notes -- don't worry about dupes and the 'x' vs 'd' logic).

        var fcFieldHighlightValues = _.values( this._getFCFields(1)).join(''),
            docProperHighlightValues = _.values( this._getDocProperties(1)).join(''),
            // Note - security & rma: these return an array so need to 'flatten'.
            // Also note that non hit values are combined with hit values in this function -- though it shouldn't hurt anything other than negligible performance.
            securityPropertyHighlightValues =  _.flatten( _.values( this._getSecurityOrRMAProperties(1, 1) )).join(''),
            rmaPropertiesHighlightValues = _.flatten( _.values( this._getSecurityOrRMAProperties(1, 0) )).join('');

        txt = fcFieldHighlightValues + docProperHighlightValues + securityPropertyHighlightValues + rmaPropertiesHighlightValues;


        if ( this.getSchemaVersion() < 3 ) {

            _.each( allNoteHitHighlights, function(noteHitHighlight) {
                // noteHitHighlight can be undefined ...
                for (var k in noteHitHighlight) {
                    if (k.indexOf('note_') > -1)
                        txt += noteHitHighlight[k][0]; // highlight values for the notes all appear to be arrays}
                }

            });

        } else {

            /**
             * Version 3: can't use allNoteHitHighlights need to know if they come from Doc Notes or Page Text
             * hits to know when to parse the delimited text for the Page Text.
             * So this isn't the most efficent ...
             */

           /* UTR Note */

            var utrNoteHighlights = this._getUTRNoteHighlightResponse();
            if ( utrNoteHighlights ) {

                var aUtrNotes = utrNoteHighlights.note;
                if ( aUtrNotes ) {
                    aUtrNotes.forEach( function( note ) {
                        txt += UTRNoteVersion3TextParser.getPageText( note );
                    });
                }
            }

            /* Doc Notes */
            var docNoteHits = this._getDocNoteHitsResp();
            if ( docNoteHits && docNoteHits.length > 0 ) {
                docNoteHits.forEach( function( docNoteHit ) {
                    if ( docNoteHit.highlight && docNoteHit.highlight.note ) {
                        txt += docNoteHit.highlight.note[0];
                    }
                });
            }
        }

        return txt;

    },
    _getAllNoteHitHighlights: function() {

        if ( !this._hasAnyResults() )
            return null;

        return _.pluck( this._getAllNoteHits(), 'highlight' );

    },


    /**
     * num_pages: doesn't appear to exist if there are no pages in the document.
     * Could also try looking at doc_pg_ids which would be an empty array if there are none in the UTR note.
     * Note: this is only the number of pages, not including 'metadata'.
     */
    numberOfPgsInDoc: function() {

        if ( !this.docOnServerAndNoFetchErr() )
            return 0;

        var docPageSrc = this._getDocumentPageSource();

        return docPageSrc && docPageSrc.num_pages
            ? docPageSrc.num_pages
            : 0;

    },
    getFetchErr: function() {
        return this.fetchErrorJQXHR;
    },

    /**
     * This this is misleading if utr notes don't exist but text notes exist (DVBC-1147).
     * Should really do a query for this but schema based on notes, not docs (which is going to change )
     * Update -- this will not change, it's based on notes.
     */
    docNotOnESServer: function() {
        return this.docNotOnES !== null;
    },
    errorOccurredOnFetch: function() {
        return this.getFetchErr() !== null;
    },
    docOnServerAndNoFetchErr: function() {
        return !this.docNotOnESServer() && !this.errorOccurredOnFetch();
    },
    isBlankSearch: function() {
        return this.searchText === '';
    },
    // Note: now this really just sets a flag so the dfds don't run
    abortAjaxRequests: function() {
       
        //TODO: get working ... 
        //_.each( this.ajaxQueue, function(jqXHR) {
        //    jqXHR.abort();
        //});

        // Don't resolve the fetch deferred -- will result in err on next doc render
        this.fetchAborted = true;
    },
    getSearchTxt: function() {
        return this.searchText;
    },

    getSchemaVersion: function() {
        return this.schemaVersion;
    }

});


//TODO: Underscore util
function order(unordered)
{
    return _.object( _.sortBy( _.pairs( unordered), function(o){
        return o[0]}
    ));
}


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/fulltext/esModel/elasticSearchModel.js
 ** module id = 403
 ** module chunks = 0
 **/